import { useSelector } from "react-redux";

import LocalStorage from "@helpers/local-storage";
import { LOCAL_STORAGE_KEYS } from '@helpers/constants';
import { getGroupHashKey } from "@containers/entities/helpers";

const useGetDefaultUpfCourseId = () => {
  const classrooms = useSelector(state => state.entitiesReducer.classrooms);
  const groups = useSelector(state => state.entitiesReducer.groups);
  const lastUsedClassroom = LocalStorage.getItem(LOCAL_STORAGE_KEYS.LAST_USED_CLASSROOM);
  const lastUsedGroup = LocalStorage.getItem(LOCAL_STORAGE_KEYS.LAST_USED_GROUP);

  const groupKey = getGroupHashKey({ classroomId: lastUsedClassroom.value, groupId: lastUsedGroup.value });
  const defaultClassromUpfCourseId = classrooms[lastUsedClassroom.value]?.defaultUpfCourseId;
  const defaultGroupUpfCourseId = groups[groupKey]?.defaultUpfCourseId;
  
  return defaultGroupUpfCourseId || defaultClassromUpfCourseId;
}

export default useGetDefaultUpfCourseId;


// WEBPACK FOOTER //
// ./helpers/hooks/use-get-default-upf-course-id.js